"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Fudao_1 = require("../Fudao");
class NullFudaoRepository {
    FudaoOfId(id) { return Fudao_1.Fudao.INVALID_FUDAO; }
    async FudaoOfIdAsync(id) { return Fudao_1.Fudao.INVALID_FUDAO; }
    async FudaoOfStatusAsync(status) { return []; }
    async SaveAsync(fudao) { }
    async LoadAsync(fudaoId) { return Fudao_1.Fudao.INVALID_FUDAO; }
    async ClearAsync() { }
}
exports.NullFudaoRepository = NullFudaoRepository;
exports.NullFudaoRepositorySingleton = new NullFudaoRepository();
//# sourceMappingURL=NullFudaoRepository.js.map